<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="chapter-6">
<h1>Chapter 6</h1>
<p>‘What was that?’ asked Albi.</p>
<p>‘It was the orb, I call her Alice,’ said Foy taking the sphere off the boy.</p>
<p>‘What are you talking about?’ asked the innkeeper, not sure what was going on.</p>
<p>‘Alice?’ asked Caoimhe.</p>
<p>‘Yeah, Alice, after a good friend of mine!’ said Foy.</p>
<p>‘Could you please tell us what you’re talking about?’ asked the innkeeper’s wife.</p>
<p>‘Didn’t you hear her?’ asked Albi.</p>
<p>‘Hear what?’ said the innkeeper.</p>
<p>‘You didn’t hear her?’ asked Caoimhe.</p>
<p>‘Hear who? Would someone please tell me what’s going on?’ said the children’s exasperated mother.</p>
<p>Holding up the golden orb so that everyone could see, Foy said, ‘May I introduce you to Alice!’</p>
<p>’You’re introducing us to a ball of gold,” said the innkeeper, giving his wife a look which left her in no doubt that he thought their new guest was completely crazy.</p>
<p>‘Yes, she understands everything you say,’ said Foy.</p>
<p>‘How do you know?’ asked the innkeeper’s wife.</p>
<p>‘Because she talks to me,’ answered Foy, leaving the children’s mother to look at the innkeeper with an expression which said, ‘You’re right, he’s nuts.’ ‘What is she?’ asked Albi.</p>
<p>‘Alice here is elfin, she told me that herself. She’s from Perigon and that’s where I’m going to take her, once I finish a little business of my own that I need to get done,’ said Foy.</p>
<p>‘Where did you find her?’ asked Caoimhe.</p>
<p>‘Eh, well, you could say I liberated her from some people who had taken her from the elves,’ said Foy looking a little guilty.</p>
<p>‘You stole her!’ Albi blurted out.</p>
<p>‘Maybe, but I searched his heart and he will return me to my people,’ Alice confidently told Albi and Caoimhe.</p>
<p>Coming closer to the orb, giving it a quick once-over, the innkeeper asked, ‘What’s it made of?’</p>
<p>‘I don’t know; she doesn’t even know that. What she did tell me was that her size is dependent on the size of her holder as she fits exactly into the palm of their hand. Alice told me she was a map and the truth is if it wasn’t for her…’ said Foy his thoughts seeming to drift off, as other memories started to come flooding back in.</p>
<p>‘What?’ asked the innkeeper’s wife.</p>
<p>‘Well, ma’am, we have a small problem,’ said Foy looking at both of the children.</p>
<p>‘And what’s that, Foy?’ asked the innkeeper.</p>
<p>’Well, as you can understand, something like Alice is much sought after, so well there are a couple of other, let us say, interested parties, undesirable types if you know what I mean, looking for her.”</p>
<p>‘Okay!’ said the innkeeper unsure as to how this was their problem.</p>
<p>Foy seemed to take a breath and consider what he was about to say next. Looking sheepish Foy said, ‘Some of these undesirables, they’re called the Warren and are well, tracking, Alice by what you might say is an invisible trail that she leaves and…’</p>
<p>Still unsure as to what the problem was, the innkeeper said, ‘Yes and…’ ‘And by the link she has with her users,’ finally finished Foy.</p>
<p>‘So that’s you!’ said the innkeeper, smiling.</p>
<p>Firstly, Foy nodded and then shook his head. ‘Yes, I am a user, of the device, but so too now are the children. Once you touch her, a link is formed and then well, as I was saying, the Warren have a trail to follow.’</p>
<p>A look of absolute horror came across the faces of both the innkeeper and his wife, however a smile erupted across both Albi’s and Caoimhe’s as they said ‘Great!’</p>
<p>‘I’m not so sure that this is really great; as you see, when—not if—they get here, they are not the sort to sit down and ask over a tankard of ale where Alice is. When they arrive, it normally involves a lot of running, shouting and screaming and rarely ends pretty,’ said Foy grimacing.</p>
<p>‘Then what are we to do?’ asked the innkeeper urgently.</p>
<p>‘Run and keep on running. I’m sorry, but there is no other way,’ said Foy sadly.</p>
<p>‘But won’t you stay and help us face them?’ the innkeeper asked desperately.</p>
<p>‘Perhaps I didn’t make myself clear, so let me say it again – run!’ said Foy adamantly.</p>
<p>‘But this is our home, this is our life,’ said the innkeeper’s wife.</p>
<p>‘And if you don’t leave, it will be your grave,’ was Foy’s blunt retort.</p>
<p>Just then the storyteller took a deep breath as he rubbed his arms for warmth, before he asked the boys, “Do you not think you need to feed the fire?”</p>
<p>No sooner had the words left the old man’s lips than Robbie ran over to the large pile of wood that Dominic and John Joe had gathered with Dessie earlier. Grabbing an armful of wood to fuel the campfire, he returned and started adding it to the dying flames. While Robbie set about building the fire back up Dessie looked at the old man and found his presence somehow familiar and reassuring, while the others felt uneasy, suspicious of what the mysterious old man truly wanted with them.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch010.vue?24293b11